import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginTokenComponent } from '@app/login-token/login-token.component';
import { LtiComponent } from '@app/lti/lti.component';
import { SchoolComponent } from '@app/school/school/school.component';
import { StudentComponent } from '@app/students/student/student.component';
import { NotAuthenticatedGuard } from '@core/guards';
import { BlogDetailsComponent } from '@layout/components/blog-details/blog-details.component';
import { BlogComponent } from '@layout/components/blog/blog.component';
import { ContactUsComponent } from '@layout/components/contact-us/contact-us.component';
import { NewsDetailsComponent } from '@layout/components/news-details/news-details.component';
import { NewsComponent } from '@layout/components/news/news.component';
import { PrivacyPolicyComponent } from '@layout/components/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from '@layout/components/terms-of-use/terms-of-use.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@app/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [NotAuthenticatedGuard],
  },
  {
    path: 'lti',
    component: LtiComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('@app/landing/landing.module').then((m) => m.LandingModule),
    pathMatch: 'full',
  },
  {
    path: 'resetpassword',
    loadChildren: () =>
      import('@app/landing/landing.module').then((m) => m.LandingModule),
    pathMatch: 'full',
  },
  {
    path: 'students',
    component: StudentComponent,
    pathMatch: 'full',
    title: 'Students',
  },
  {
    path: 'coding-in-schools',
    component: SchoolComponent,
    pathMatch: 'full',
    title: 'Schools',
  },
  {
    path: 'termsOfUse',
    component: TermsOfUseComponent,
    pathMatch: 'full',
    title: 'Terms Of Use ',
  },
  {
    path: 'privacyPolicy',
    component: PrivacyPolicyComponent,
    pathMatch: 'full',
    title: 'Privacy Policy',
  },
  {
    path: 'contact',
    component: ContactUsComponent,
    pathMatch: 'full',
    title: 'Contact Us',
  },
  {
    path: 'blog',
    component: BlogComponent,
    pathMatch: 'full',
    title: 'Blog',
  },
  {
    path: 'news',
    component: NewsComponent,
    pathMatch: 'full',
    title: 'News',
  },
  {
    path: 'news/:title',
    component: NewsDetailsComponent,
    pathMatch: 'full',
    title: 'News Details',
  },
  {
    path: 'blog/:title',
    component: BlogDetailsComponent,
    pathMatch: 'full',
    title: 'Blog Details',
  },
  {
    path: 'login-token',
    component: LoginTokenComponent,
    title: '',
  },
  // For QR module
  {
    path: 'certificate',
    loadChildren: () => import('@app/qr/qr.module').then((m) => m.QrModule),
  },
  {
    path: ':lang/login-token',
    component: LoginTokenComponent,
    title:'',
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
